import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/CustomBox/config';
import cn from 'classnames';
import s from './CustomBox.scss';
const CustomBoxViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "custombox",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
CustomBoxViewer.displayName = 'CustomBoxViewer';
export default CustomBoxViewer;

//# sourceMappingURL=CustomBox.js.map